<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li class="nav-item" style="cursor:pointer">
            <span class="nav-link" [ngClass]="{'active': !show_bagitem}" (click)="show_bagitem=false">公告設定</span>
        </li>
        <li class="nav-item" style="cursor:pointer">
            <span class="nav-link" [ngClass]="{'active': show_bagitem}" (click)="show_bagitem=true">背包道具管理</span>
        </li>
    </ul>

    <!-- 背包道具管理（bag_item_list CRUD）：與公告設定以頁籤切換 -->
    <div *ngIf="show_bagitem" style="margin-top:10px">
        <app-bagitem></app-bagitem>
    </div>

    <div style="margin-top:10px" *ngIf="!show_bagitem">

        <app-check-permissions [data]="'hxUB'">
            <button data-toggle="modal" (click)="get_default();" data-target=".bd-example-modal-xl" class="btn btn-primary mb-3">新增公告</button>
        </app-check-permissions>

        類型
        <select class="form-control" style="width: 160px;display: inline-block;margin-right: 2%;margin-bottom: 2%;" [(ngModel)]="announcement_status" (change)="pageobj.page=0;init_list()">
            <option *ngFor="let item of announcement_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        狀態
        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="announc_isenablelist_status" (change)="pageobj.page=0;init_list()">
            <option *ngFor="let item of announc_isenablelist" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata1($event)"> 
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'banner_pic'">
                    <img loading="lazy"  [src]="post.val.banner_pic" alt="" style="height: 120px">    
                </div>
                <div *ngIf="post.key == 'popup_pic'">
                    <img loading="lazy"  [src]="post.val.popup_pic" alt="" style="height: 120px">    
                </div>
                <div *ngIf="post.key=='contentg'" [ngClass]="{'ellipsis': post.val.content.length > 50}">
                    <p [innerHTML]="post.val.content | slice:0:50"></p>
                    <span *ngIf="post.val.content.length > 50">...</span>
                </div>
                <div *ngIf="post.key == 'gg'" style="display: flex">
                    <a href="javascript:void(0)" title="設定"  (click)="edit_data=post.val;onGiftCheckSelected();dateTime(post.val);get_story();getlottery(post.val);load_rank(post.val)" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                    <app-check-permissions [data]="'ORa6'">
                        <a href="javascript:void(0)" title="複製"  (click)="copy(edit_data=post.val);">
                            <i style="margin: 0 10px 0 0;" class="fas fa-copy"></i>
                        </a>
                        <a href="javascript:void(0)" title="刪除"  (click)="del(edit_data=post.val);">
                            <i style="margin: 0 10px 0 0;" class="fas fa-trash"></i>
                        </a>
                    </app-check-permissions>
                    <a href="javascript:void(0)" title="查看派獎" *ngIf="post.val.type  == '2' && post.val.category  != '28'  && post.val.category  == '22' "  (click)="click(post.val);" data-toggle="modal" data-target=".bd-example1-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-book"></i>
                    </a>

                    <a href="javascript:void(0)" title="幸運開獎" *ngIf="post.val.category  == '28' "  (click)="luckylist(post.val);" data-toggle="modal" data-target=".bd-example1-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-book"></i>
                    </a>

                    <a href="javascript:void(0)" title="匯出" (click)="exportexcel(post.val);" *ngIf="post.val.category  == '22' ">
                        <i class="fa fa-download"></i>
                    </a>
                    <!-- <a [href]="urltoken" *ngIf="urltoken.length>0 && data.length>0" style="margin:10px;font-size: 20px;"  target="_blank">
                        <i class="fa fa-download"></i>
                    </a> -->
                </div>
                <div *ngIf="post.key == 'is_enable'">
                    <span>{{annoucestatuses[ +post.val.is_enable + 2 ]}}</span>
                </div>
            </ng-template>
        </app-table-v2>     
        <div *ngIf="data.length==0">無資料</div>
    </div>

    <div 
        *ngIf="edit_data"
        class="modal fade bd-example-modal-xl" tabindex="-1"
        role="dialog"  data-keyboard="false" data-backdrop="static" 
        aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    >
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">{{edit_data.id==-1?'新增':'修改'}}</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
          
                <!-- Modal body -->
                <div class="modal-body">
                    <h4 class="h4title title1">身分設定</h4>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">作業系統</label>
                        <button [ngClass]="edit_data.os == 0?'btn-success':'btn-secondary'"  (click)="edit_data.os = 0" class="btn modalbtn">不限</button>
                        <button [ngClass]="edit_data.os == 1?'btn-success':'btn-secondary'" (click)="edit_data.os = 1" class="btn modalbtn">Android</button>          
                        <button [ngClass]="edit_data.os == 2?'btn-success':'btn-secondary'" (click)="edit_data.os = 2" class="btn modalbtn">iOS</button>          
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">性別</label>
                        <button [ngClass]="edit_data.gender == 0?'btn-success':'btn-secondary'"  (click)="edit_data.gender = 0" class="btn modalbtn">不限</button>
                        <button [ngClass]="edit_data.gender == 1?'btn-success':'btn-secondary'" (click)="edit_data.gender = 1" class="btn modalbtn">男</button>          
                        <button [ngClass]="edit_data.gender == 2?'btn-success':'btn-secondary'" (click)="edit_data.gender = 2" class="btn modalbtn">女</button>          
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">身分</label>
                        <label *ngFor="let item of identity_list">
                                <div style="margin-right: 10px;">
                                    <div style="padding-right: 13px;margin-left: -13px;                                    ">    
                                        <input type="checkbox" [value]="item.id" [(ngModel)]="edit_data.identity_listItems[item.id]" class="checkboxlabel"/>
                                        {{ item.name }}
                                    </div>
                                </div>
                        </label>
                    </div>

                    <h4 class="h4title title2">內容設定</h4>
                    
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">類型</label>
                        <button [ngClass]="edit_data.type==1?'btn-success':'btn-secondary'"  (click)="edit_data.type=1" class="btn modalbtn">一般</button>
                        <button [ngClass]="edit_data.type==2?'btn-success':'btn-secondary'" (click)="edit_data.type=2" class="btn modalbtn">活動</button>          
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">子類型</label>

                        <select class="form-control"
                            style="width: 160px;display: inline-block;"
                            [(ngModel)]="edit_data.category"
                            (ngModelChange)="get_story()"
                        >
                            <ng-container *ngIf="edit_data.type == '1'">
                                <option *ngFor="let item of category_list" [ngValue]="item.id">{{item.name}}</option>
                            </ng-container>
                            <ng-container *ngIf="edit_data.type == '2'">
                                <option *ngFor="let item of category_list1" [ngValue]="item.id">{{item.name}}</option>
                            </ng-container>
                        </select>              
                    </div>  
                    
                    <div class="user_edit_block form-group" *ngIf="edit_data.category == 27 && edit_data.type == 2">
                        <label class="col-sm-2 col-form-label custom">動態主題類型</label>

                        <select class="form-control"
                            style="width: 160px;display: inline-block;"
                            [(ngModel)]="edit_data.story_active_id"
                        >
                            <option default disabled value="-2">請選擇動態主題</option>
                            <option *ngFor="let item of story_active_list" [ngValue]="item.id">{{item.name}}</option>
                        </select>              
                    </div>  

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">標題</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.title">                          
                    </div>

                    <div class="user_edit_block form-group" style="display: flex;">
                        <label class="col-sm-2 col-form-label custom">內容</label>
                        <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="edit_data.content"></textarea>                         
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">是否顯示在列表</label>
                        <button [ngClass]="edit_data.show_list==0?'btn-success':'btn-secondary'" (click)="edit_data.show_list=0" class="btn modalbtn">否</button>
                        <button [ngClass]="edit_data.show_list==1?'btn-success':'btn-secondary'" (click)="edit_data.show_list=1" class="btn modalbtn">是</button>  
                    </div>               

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">是否顯示在Banner</label>
                        <button [ngClass]="edit_data.show_banner==0?'btn-success':'btn-secondary'" (click)="edit_data.show_banner=0" class="btn modalbtn">否</button>
                        <button [ngClass]="edit_data.show_banner==1?'btn-success':'btn-secondary'" (click)="edit_data.show_banner=1" class="btn modalbtn">是</button>  
                    </div>

                    <div  *ngIf="edit_data.show_banner==1" class="user_edit_block form-group"  style="display: flex;">
                        <label class="col-sm-2 col-form-label custom">Banner圖</label>

                        <!-- 圖片裁切功能 -->
                        <div *ngIf="ImgType == false">
                            <app-img-cropper [editData]="edit_data.tmp_img_b64_ban" (imageUpload)="handleImageUpload($event,1,0)"></app-img-cropper>
                        </div>
                        
                        <!-- 一般圖片上傳功能 -->
                        <div *ngIf="ImgType == true">
                            <app-img  [editData]="edit_data.tmp_img_b64_ban" (imageUpload)="handleImageUpload($event,1,1)"></app-img>
                        </div>
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">是否顯示在彈跳視窗</label>
                        <button [ngClass]="edit_data.show_popup==0?'btn-success':'btn-secondary'" (click)="edit_data.show_popup=0" class="btn modalbtn">否</button>        
                        <button [ngClass]="edit_data.show_popup==1?'btn-success':'btn-secondary'" (click)="edit_data.show_popup=1" class="btn modalbtn">是</button>  
                    </div>

                    <div class="user_edit_block form-group" *ngIf="edit_data.type == 2 && edit_data.category == 28">
                        <label class="col-sm-2 col-form-label custom">選擇兌獎模式</label>
                        
                        <button [ngClass]="edit_data.lotteryrewards.open_type==1?'btn-success':'btn-secondary'" (click)="edit_data.lotteryrewards.open_type=1" class="btn modalbtn">摸彩</button>        
                        <button [ngClass]="edit_data.lotteryrewards.open_type==2?'btn-success':'btn-secondary'" (click)="edit_data.lotteryrewards.open_type=2" class="btn modalbtn">樂透</button>  
                        <button [ngClass]="edit_data.lotteryrewards.open_type==3?'btn-success':'btn-secondary'" (click)="edit_data.lotteryrewards.open_type=3" class="btn modalbtn">雙重兌獎</button>  
                    </div>

                    <div *ngIf="edit_data.show_popup==1"  class="user_edit_block form-group" style="display: flex;">
                        <label class="col-sm-2 col-form-label custom">彈跳視窗圖</label>

                        <!-- 圖片裁切功能 -->
                        <div *ngIf="ImgType == false">
                            <app-img-cropper [editData]="edit_data.tmp_img_b64" (imageUpload)="handleImageUpload($event,0,0)"></app-img-cropper>
                        </div>
                        <!-- 一般圖片上傳功能 -->
                        <div *ngIf="ImgType == true">
                            <app-img  [editData]="edit_data.tmp_img_b64" (imageUpload)="handleImageUpload($event,0,1)"></app-img>
                        </div>
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">活動日期</label>

                        <app-date [time]="time" [timeset]="timeset" [limitset]="limitset" [format]="'YYYY-MM-DD HH:mm:ss'" [css]="'width: 420px; display: inline-block; margin-right: 16px;'" (rangeSelected)="handleRangeSelected($event)"></app-date>
                    </div>

                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">banner排序分數</label>
                        <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.sort_score" pattern="[0-9]*" min="0">                          
                    </div>


                    <div *ngIf="edit_data.type == 2 && edit_data.category == 22">
                        <h4 class="h4title title3">競賽獎勵設定</h4>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">競賽獎勵</label>
                           
                        </div>   
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">請輸入競賽LV</label>
                            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.lv" pattern="[0-9]*" min="1">                          
                            <button [ngClass]="'btn-success'" class="btn modalbtn" style="margin-left: 15px;" (click)="addLv()">新增獎勵LV</button>
                        </div>   

                        <div *ngFor="let lv of edit_data.lvTotal; let i = index" class="user_edit_block form-group" >
                            <div class="accordion" id="accordionExample">
                                <div class="card">
                                    <div class="card-header" [id]="'heading' + i">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left" type="button" 
                                                    data-toggle="collapse"
                                                    [attr.data-target]="'#collapseOne' + i"
                                                    [attr.aria-expanded]="true" 
                                                    [attr.aria-controls]="'collapseOne' + i">
                                                LV{{ lv }}
                                            </button>
                                        </h2>
                                    </div>
                                
                                    <div [id]="'collapseOne' + i" class="collapse show" [attr.aria-labelledby]="'heading' + i" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <button [ngClass]="'btn-success'" class="btn modalbtn" style="margin-left: 15px;" (click)="addReward(lv)">新增獎勵LV</button>
                                            <div *ngFor="let reward of edit_data.rewards; let i = index" class="user_edit_block form-group">
                                                <div *ngFor="let rewas of reward[lv]; let n = index" class="user_edit_block form-group">
                                                    <div class="user_edit_block form-group">
                                                        <label class="col-sm-2 col-form-label custom">獎勵名稱{{n + 1}}</label>
                                                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="rewas.name">  
                                                    </div>
                                                    <div class="user_edit_block form-group">
                                                        <label class="col-sm-2 col-form-label custom">鑽石數量{{n + 1}}</label>
                                                        <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="rewas.diamond" pattern="[0-9]*" min="0">                          
                                                    </div>
                                                    <div class="user_edit_block form-group">
                                                        <label class="col-sm-2 col-form-label custom">票券數量{{n + 1}}</label>
                                                        <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="rewas.ticket" pattern="[0-9]*" min="0">                          
                                                    </div>
                                                    <div class="user_edit_block form-group">
                                                        <label class="col-sm-2 col-form-label custom">排名{{n + 1}}</label>
                                                        <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="rewas.rank" pattern="[0-9]*" min="0" (change)="handleRankInput(lv,n+1 ,i)">                          

                                                    </div>
                                                    <div class="user_edit_block form-group">
                                                        <label class="col-sm-2 col-form-label custom">數量{{n + 1}}</label>
                                                        <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="rewas.num" pattern="[0-9]*" min="0">                          

                                                        </div>

                                                    <div style="text-align: center;">    
                                                        <button [ngClass]="'btn-success'" class="btn modalbtn" (click)="cancelReward(n,lv)">取消獎勵{{n + 1}}</button>
                                                    </div>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">競賽類型</label>
                            <button [ngClass]="edit_data.competition_type == 1?'btn-success':'btn-secondary'"  (click)="edit_data.competition_type = 1" class="btn modalbtn">收益</button>
                            <button [ngClass]="edit_data.competition_type == 2?'btn-success':'btn-secondary'" (click)="edit_data.competition_type = 2" class="btn modalbtn">消費</button>          
                            <button [ngClass]="edit_data.competition_type == 3?'btn-success':'btn-secondary'" (click)="edit_data.competition_type = 3" class="btn modalbtn">儲值</button>          
                        </div>


                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">競賽計算方式</label>
                            <button [ngClass]="edit_data.competition_count_type == 1?'btn-success':'btn-secondary'"  (click)="edit_data.competition_count_type = 1" class="btn modalbtn">鑽石數</button>
                            <button [ngClass]="edit_data.competition_count_type == 2?'btn-success':'btn-secondary'" (click)="edit_data.competition_count_type = 2" class="btn modalbtn">次數</button>
                        </div>

                        <!-- 等級/門檻設定（user_rank / user_rank_lv）：依此活動 aid 綁定，沿用 /update_user_rank.php -->
                        <h4 class="h4title title3">等級/門檻設定</h4>
                        <div *ngIf="rank_data.has != '0'" style="color:#d33;margin-bottom:8px;">
                            此活動已有人獲得稱號，僅能修改「等級名稱 / 門檻 / 升級獎勵」，不可增刪等級或變更其他設定。
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">稱號名稱</label>
                            <input type="text" class="form-control" style="display: inline-block;width: 320px;" [(ngModel)]="rank_data.name" placeholder="例：202607電愛西施視訊限時競賽">
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">稱號性別</label>
                            <button [ngClass]="rank_data.gender == 1?'btn-success':'btn-secondary'" (click)="rank_data.gender = '1'" class="btn modalbtn" [disabled]="rank_data.has != '0'">男</button>
                            <button [ngClass]="rank_data.gender == 2?'btn-success':'btn-secondary'" (click)="rank_data.gender = '2'" class="btn modalbtn" [disabled]="rank_data.has != '0'">女</button>
                        </div>
                        <div class="user_edit_block form-group">
                            <button [ngClass]="'btn-success'" class="btn modalbtn" (click)="addRankLv()" [disabled]="rank_data.has != '0'">新增等級</button>
                        </div>
                        <div *ngFor="let d of rank_data.detail; let ri = index" class="user_edit_block form-group" style="border:1px solid #eee;padding:8px;margin-bottom:6px;">
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">等級名稱{{ri + 1}}</label>
                                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="d.name">
                            </div>
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">進入門檻{{ri + 1}}</label>
                                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="d.diamond_start" pattern="[0-9]*" min="0">
                            </div>
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">升級獎勵鑽石{{ri + 1}}</label>
                                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="d.once_reward" pattern="[0-9]*" min="0">
                            </div>
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">是否實際計算{{ri + 1}}</label>
                                <button [ngClass]="d.real_info == 1?'btn-success':'btn-secondary'" (click)="d.real_info = '1'" class="btn modalbtn" [disabled]="rank_data.has != '0'">是</button>
                                <button [ngClass]="d.real_info == 0?'btn-success':'btn-secondary'" (click)="d.real_info = '0'" class="btn modalbtn" [disabled]="rank_data.has != '0'">否(僅顯示門檻)</button>
                            </div>
                            <div style="text-align:center;">
                                <button [ngClass]="'btn-danger'" class="btn modalbtn" (click)="delRankLv(ri)" [disabled]="rank_data.has != '0'">刪除等級{{ri + 1}}</button>
                            </div>
                        </div>

                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">競賽納入計算</label>
                            <div class="user_edit_block form-group">
                                <label *ngFor="let item of items">
                                    <input type="checkbox" [value]="item.id" [(ngModel)]="edit_data.selectedItems[item.id]" class="checkboxlabel"/>
                                    {{ item.name }}
                                </label>
                            </div>
                        </div>

                        <div *ngIf="edit_data.selectedItems[10] || edit_data.selectedItems[-2]">
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">禮物名稱</label>
                                <select class="form-control"
                                    style="width: 160px;display: inline-block;"
                                    [(ngModel)]="edit_data.gift"
                                    (ngModelChange)="onGiftSelected($event)"
                                >
                                    <option *ngFor="let item of gift_list" [ngValue]="item.id">{{item.name}}</option>
                                </select>              
                            </div>

                            <div  style="margin-top: 20px;">
                                <label *ngFor="let item of edit_data.giftNdetail">
                                    <div style="margin-right: 10px;">
                                        <div style="text-align: center;">
                                            <img loading="lazy" style="height: 80px" [src]="[item.pic]">
                                        </div>
                                        <div style="padding-right: 13px">    
                                            <input type="checkbox" [value]="item.id" [(ngModel)]="edit_data.giftdetailItems[item.id]"  (ngModelChange)="onGiftCheckSelected()" class="checkboxlabel"/>
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div *ngIf="edit_data.selectedItems[10] || edit_data.selectedItems[-2]" style="background-color: blanchedalmond;">
                            <label class="col-sm-2 col-form-label custom">已選禮物</label>
                            <div  style="margin-top: 20px;">
                                <label *ngFor="let selectedGift of edit_data.giftSelectdetail">
                                    <div style="margin-right: 10px;">
                                        <div style="text-align: center;">
                                            <img loading="lazy" style="height: 80px" [src]="[selectedGift.pic]">
                                        </div>
                                        <div style="padding-right: 13px;text-align: center;">    
                                            {{ selectedGift.name }}
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div *ngIf="(edit_data.selectedItems[-1] || edit_data.selectedItems[-2]) && bag_list[0] != null">
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label custom">背包物品</label>      
                            </div>

                            <div style="margin-top: 20px;">
                                <label *ngFor="let item of bag_list">
                                    <div style="margin-right: 10px;">
                                        <div style="text-align: center;">
                                            <img loading="lazy" style="height: 80px" [src]="[item.pic]">
                                        </div>
                                        <div style="padding-right: 13px">    
                                            <input type="checkbox" [value]="item.id" [(ngModel)]="edit_data.bagdetailItems[item.id]" class="checkboxlabel"/>
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </label>
                            </div>  
                        </div>

                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">可獲獎門檻</label>
                            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.competition_threshold" pattern="[0-9]*" min="0">                          
                        </div>
                    </div>

                    <div *ngIf="edit_data.type == 2 && edit_data.category == 28 && (edit_data.lotteryrewards.open_type == 1 || edit_data.lotteryrewards.open_type == 3)">
                        <div class="accordion" id="accordionExample">
                            <div class="card">
                                <div class="card-header" [id]="'heading'">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link btn-block text-left" type="button" 
                                                data-toggle="collapse"
                                                [attr.data-target]="'#collapseOne'"
                                                [attr.aria-expanded]="true" 
                                                [attr.aria-controls]="'collapseOne'">
                                                摸彩活動設定
                                        </button>
                                    </h2>
                                </div>

                                <div [id]="'collapseOne'" class="collapse show" [attr.aria-labelledby]="'heading'" data-parent="#accordionExample">
                                    <div class="card-body">
                                        <button [ngClass]="'btn-success'" class="btn modalbtn" style="margin-left: 15px;" (click)="addLotteryReward()">新增獎勵LV</button>
                                        <div *ngFor="let reward of edit_data.lotteryrewards.lottery; let n = index" class="user_edit_block form-group">
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">LV{{n + 1}}</label>
                                                <p style="font-size: 10px;margin-top: -12px;">LV越小獎項越大</p>
                                                <input type="text" class="form-control" style="display: none;width: 220px;" [(ngModel)]="reward.lv" disabled="disabled">   
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">摸彩類型{{n + 1}}</label>
                                                <button [ngClass]="reward.type==1?'btn-success':'btn-secondary'" (click)="reward.type=1" class="btn modalbtn">鑽石</button>
                                                <button [ngClass]="reward.type==2?'btn-success':'btn-secondary'" (click)="reward.type=2" class="btn modalbtn">實體</button>  
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">摸彩名稱{{n + 1}}</label>
                                                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.name">  
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <div style="display: flex;">
                                                    <label class="col-sm-2 col-form-label custom">摸彩內定人員{{n + 1}}</label>
                                                    <app-search  [id]="n"  [openModel]="false" (item)="callitem($event,reward,n)" style="margin-right: 3%;"></app-search>
                                                    <button [ngClass]="'btn-success'" (click)="default_person(reward,n)"   class="btn modalbtn">預設內定人員</button>  
                                                </div>
                                            
                                                <div *ngIf="user_search[n] != undefined">
                                                    <button  *ngFor="let item of user_search[n]; let i = index"  style="margin: 10px;" class="btn btn-info" (click)="clearbtnuser(i,n,reward)">{{item.name}}</button>
                                                </div>
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">摸彩鑽石{{n + 1}}</label>
                                                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.diamond" pattern="[0-9]*" min="0" [attr.disabled]="reward.type == 2 ? true : null">                          
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">摸彩備注{{n + 1}}</label>
                                                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.des">                          
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">摸彩狀態{{n + 1}}</label>
                                                <button [ngClass]="(reward.open==false || reward.open=='false')?'btn-success':'btn-secondary'" (click)="reward.open=false" class="btn modalbtn">停用</button>
                                                <button [ngClass]="(reward.open==true || reward.open=='true')?'btn-success':'btn-secondary'" (click)="reward.open=true" class="btn modalbtn">啟用</button>  
                                            </div>
                                            <div style="text-align: center;">    
                                                <button [ngClass]="'btn-success'" class="btn modalbtn" (click)="cancelLotteryReward(n)">取消摸彩{{n + 1}}</button>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="edit_data.type == 2 && edit_data.category == 28  && (edit_data.lotteryrewards.open_type == 2 || edit_data.lotteryrewards.open_type == 3)">
                        <div class="accordion" id="accordionExamples">
                            <div class="card">
                                <div class="card-header" [id]="'heading'">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link btn-block text-left" type="button" 
                                                data-toggle="collapse"
                                                [attr.data-target]="'#collapseOnea'"
                                                [attr.aria-expanded]="true" 
                                                [attr.aria-controls]="'collapseOnea'">
                                                樂透活動設定
                                        </button>
                                    </h2>
                                </div>

                                <div [id]="'collapseOnea'" class="collapse show" [attr.aria-labelledby]="'heading'" data-parent="#accordionExamples">
                                    <div class="card-body">
                                        <div *ngFor="let reward of edit_data.lotteryrewards.invoice; let n = index" class="user_edit_block form-group">
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">LV{{n + 1}}</label>
                                                <p style="font-size: 10px;margin-top: -12px;">LV越小獎項越大</p>
                                                <input type="text" class="form-control" style="display: none;width: 220px;" [(ngModel)]="reward.lv" disabled="disabled">   
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透類型{{n + 1}}</label>
                                                <button [ngClass]="reward.type==1?'btn-success':'btn-secondary'" (click)="reward.type=1" class="btn modalbtn">鑽石</button>
                                                <button [ngClass]="reward.type==2?'btn-success':'btn-secondary'" (click)="reward.type=2" class="btn modalbtn">實體</button>  
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透名稱{{n + 1}}</label>
                                                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.name">  
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <div style="display: flex;">
                                                    <label class="col-sm-2 col-form-label custom">樂透內定人員{{n + 1}}</label>
                                                    <app-search  [id]="n"  [openModel]="false" (item)="callitem($event,reward,n)"></app-search>
                                                </div>
                                            
                                                <div *ngIf="user_search[n] != undefined">
                                                    <button  *ngFor="let item of user_search[n]; let i = index"  style="margin: 10px;" class="btn btn-info" (click)="clearbtnuser(i,n,reward)">{{item.name}}</button>
                                                </div>
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透鑽石{{n + 1}}</label>
                                                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.diamond" pattern="[0-9]*" min="0" [attr.disabled]="reward.type == 2 ? true : null">                          
                                            </div><div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透限制數{{n + 1}}</label>
                                                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.limit" pattern="[0-9]*" min="0" [attr.disabled]="reward.type == 2 ? true : null">                          
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透備注{{n + 1}}</label>
                                                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="reward.des">                          
                                            </div>
                                            <div class="user_edit_block form-group">
                                                <label class="col-sm-2 col-form-label custom">樂透狀態{{n + 1}}</label>
                                                <button [ngClass]="(reward.open==false || reward.open=='false')?'btn-success':'btn-secondary'" (click)="reward.open=false" class="btn modalbtn">停用</button>
                                                <button [ngClass]="(reward.open==true || reward.open=='true')?'btn-success':'btn-secondary'" (click)="reward.open=true" class="btn modalbtn">啟用</button>  
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 class="h4title title4">連結設定</h4>
                    <div class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">連結方式</label>
                        <button [ngClass]="edit_data.link_type == 0?'btn-success':'btn-secondary'"  (click)="edit_data.link_type = 0" class="btn modalbtn">無連結</button>
                        <button [ngClass]="edit_data.link_type == 1?'btn-success':'btn-secondary'" (click)="edit_data.link_type = 1" class="btn modalbtn">導內</button>          
                        <button [ngClass]="edit_data.link_type == 2?'btn-success':'btn-secondary'" (click)="edit_data.link_type = 2" class="btn modalbtn">導外</button>          
                    </div>

                    <div *ngIf="edit_data.link_type == 1" class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">導內-頁面編號</label>
                        <select class="form-control"
                            style="width: 250px;display: inline-block;"
                            [(ngModel)]="edit_data.route_sign "
                        >
                            <option *ngFor="let item of route_sign_list" [ngValue]="item.id">{{item.id}}:{{item.name}}</option>
                            <ng-container *ngIf="edit_data.type == '1'; else elseBlock">
                                <option  [ngValue]="'15'">15:指定淘妹公告資訊列表</option>
                                <option  [ngValue]="'19'">19:指定淘妹公告資訊</option>
                            </ng-container>
                            <ng-template #elseBlock>
                                <option [ngValue]="'17'">17:指定活動細節內頁</option>
                            </ng-template>
                        </select> 
                    </div>
<!-- 
                    <div *ngIf="edit_data.link_type == 1" class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">導內-API路徑</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.route_path"> 
                    </div> -->

                    <div *ngIf="edit_data.link_type == 2" class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">導外-連結網址</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.external_url">                          
                    </div>

                    <div *ngIf="edit_data.link_type == 1" class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">內頁按鈕文字</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.btn_name">                          
                    </div>

                    <div *ngIf="edit_data.link_type == 1"  class="user_edit_block form-group">
                        <label class="col-sm-2 col-form-label custom">內頁按鈕連結</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.btn_url">                          
                    </div>    
                  
                    <div class="user_edit_block form-group" *ngIf="false">
                        <label class="col-sm-2 col-form-label custom">存取狀態</label>
                        <button [ngClass]="edit_data.is_enable == -2?'btn-success':'btn-secondary'"  (click)="edit_data.is_enable = -2" class="btn modalbtn">強制下架</button>
                        <button [ngClass]="edit_data.is_enable == -1?'btn-success':'btn-secondary'" (click)="edit_data.is_enable = -1" class="btn modalbtn">已過期</button>          
                        <button [ngClass]="edit_data.is_enable == 0?'btn-success':'btn-secondary'" (click)="edit_data.is_enable = 0" class="btn modalbtn">待上架</button>          
                        <button [ngClass]="edit_data.is_enable == 1?'btn-success':'btn-secondary'" (click)="edit_data.is_enable = 1" class="btn modalbtn">上架中</button>          
                    </div>                  
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <app-check-permissions [data]="'ORa6'">
                        <button id="ModalClose" type="button" (click)="add()" class="btn btn-primary" data-dismiss="modal">{{edit_data.id==-1?'新增':'修改'}}</button>
                    </app-check-permissions>
                    <button id="ModalClose" type="button" class="btn btn-danger" data-dismiss="modal">取消</button>
                </div>
            </div>
        </div>
    </div>


    <div 
        *ngIf="edit_data"
        class="modal fade bd-example1-modal-xl" tabindex="-1"
        role="dialog"  data-keyboard="false" data-backdrop="static" 
        aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    >
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="lottery_type == 1">參加活動人員清單</h5>
                    <h5 class="modal-title" *ngIf="lottery_type == 2">幸運開獎</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
          
                <!-- Modal body -->
                <div class="modal-body" *ngIf="lottery_type == 1"> 
                    <h6 class="modal-title">獲獎門檻 : {{competition_threshold}}</h6>
                    <h6 class="modal-title" *ngIf="dataItem?.end_dt">執行派獎時間 : {{ calculateNextDay(dataItem.end_dt) | date: 'yyyy-MM-dd HH:mm' }}</h6>
                    <app-table-v2  *ngIf="dataDetail.length>0" [type]="1" [tcontent]="tcontent2" [data]="dataDetail" [pageobj]="pageobj3" (countp)="handlepage($event)" (sortdata)="handlesortdata($event)">
                        <ng-template let-post #operation_dk>
                            <div *ngIf="post.key == 'sum_diamond'">
                                <p [ngStyle]="{ color: post.val.sum_diamond * 1 > competition_threshold * 1 ? 'inherit' :'brown'}" class="diamondclass">
                                    {{ post.val.sum_diamond }}
                                </p>
                            </div>
                            <div *ngIf="post.key == 'qualifications'">
                                {{ post.val.sum_diamond * 1 > competition_threshold * 1 ? '是' :'否' }}
                            </div>
                        </ng-template>
                    </app-table-v2>
                    <div>
                        <app-pagnation (callback)="callback3($event)"  [data]="pageobjstr3"  *ngIf="dataDetail.length>0"></app-pagnation> 
                    </div>   

                </div>
                <div class="modal-body" *ngIf="lottery_type == 2 && isDesktop == true"> 
                    <div class="container">
                        <div class="main-content">
                            <h5>獎項： {{nowimagePrice}}</h5>
                            <div class="carousel">
                                <div class="images" #carousel>
                                    <ng-container *ngFor="let image of imageA">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageB">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageC">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>  
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageD">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>  
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="black">
                            </div>
                            <button class="lottery-button" *ngIf="btnstatus == 0" (click)="startLottery()">開獎</button>
                            <button class="lottery-button" *ngIf="btnstatus == 1">開獎中</button>
                            <button class="lottery-button" *ngIf="btnstatus == 2">開獎完成</button>
                        </div>
                        <div class="sidebar">
                            <h2>獎項</h2>
                            <ul>
                                <li *ngFor="let image of imagePrice; let i = index">
                                    <p> {{image.name}} </p><p class="getreward" *ngIf="image.status == 1">{{PriceMember[i]?.name}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="modal-body" *ngIf="lottery_type == 2 && isDesktop == false"> 
                    <div class="container">
                        <div class="main-content">
                            <h5>獎項： {{nowimagePrice}}</h5>
                            <div class="carousel">
                                <div class="images" #carousel>
                                    <ng-container *ngFor="let image of imageA">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageB">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageC">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>
                                        </div>  
                                    </ng-container>
                                    <ng-container *ngFor="let image of imageD">
                                        <div [class]="image.class">
                                            <img loading="lazy" [src]="image.url" [alt]="image.url">
                                            <p style="margin-bottom: 0px;">{{image.name}}</p>  
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="black">
                            </div>
                            <button class="lottery-button" *ngIf="btnstatus == 0" (click)="startLottery()">開獎</button>
                            <button class="lottery-button" *ngIf="btnstatus == 1">開獎中</button>
                            <button class="lottery-button" *ngIf="btnstatus == 2">開獎完成</button>
                        </div>
                    </div>
                    <div class="bottom">
                        <h2>獎項</h2>
                        <ul>
                            <li *ngFor="let image of imagePrice; let i = index">
                                <p> {{image.name}} </p><p class="getreward" *ngIf="image.status == 1">{{PriceMember[i]?.name}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer" *ngIf="lottery_type == 1">
                    <button id="ModalClose" type="button" class="btn btn-danger" data-dismiss="modal">關閉</button>
                </div>
                <div class="modal-footer" *ngIf="lottery_type == 2">
                    <button id="ModalClose" type="button" class="btn btn-danger" data-dismiss="modal" (click)="init_list()">關閉</button>
                </div>
            </div>
        </div>
    </div>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr" *ngIf="!show_bagitem"></app-pagnation>
    <app-spinner [loading]="loading"></app-spinner>
    <app-toast></app-toast>

</div>